import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import store from '../store';
import {observer} from 'mobx-react';
import Helmet from 'react-helmet';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import OpenApp from './../components/OpenApp';
import Login from './../components/Login';
import PhotoSwipeGallery from '../components/live/PhotoSwipeGallery';
import OpenAppChannel from '../components/OpenAppChannel';
import {getUseParams, setUrl, removeCookies} from '../utils/baseUtil';
import {setWeixinData} from '../utils/wxShareUtil';
import {formatExpression} from '../utils/expression';
import videojs from 'video.js';
import 'videojs-contrib-hls.js';
import MeScroll from 'mescroll.js';

dayjs.locale('zh-cn');

let mescrollDom = null;
let page = '';
let interactionList = [];
let imageLiveList = [];
let connectTimer = null;
let intervalTimer = null;
let errorTimer = null;

var player;// 视频控制器
var timeID;// 直播倒计时 setInterval
var teletextWs; // 图文直播 websocket的实例
var interactionWs; // 互动 websocket的实例
var menuList = [{key:1,name:'图文直播'},{key:2,name:'文字稿'},{key:3,name:'文件'},{key:4,name:'详情'},{key:5,name:'互动'}];
var pannelKey;
// 单位换算
const numberUtil = (num) => {
  if (typeof num === 'number') {
    if (num >= 10000) return (num / 10000).toFixed(1).concat('w');
    else if (num >= 1000) return (num / 1000).toFixed(1).concat('k');
    else return num
  }
  return num
};

const getWindowHeight = () => {
  let windowHeight = 0;
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight;
  } else{
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
};

const Live = () => {
  const location = useLocation();
  const query = getUseParams(location.search);
  const [detail, setDetail] = useState({});
  const [timerText,setTimerText] = useState('00天 00时 00分');
  const [showPlayButton, setShowPlayButton] = useState(true);
  const [playError, setPlayError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [menuTabKey,setMenuTabKey] = useState(1);
  const [orderBy,setOrderBy] = useState('desc');//直播间排序方式,升序asce:,降序:desc
  const [imageLiveData,setImageLiveData] = useState([]);
  const [interactionData,setInteractionData] = useState([]);
  const [showLogin,setShowLogin] = useState(false);

  const token = store.token || '';

  useEffect(() => {
    return () => {
      clearTimeout(errorTimer);
    }
  }, []);

  useEffect(() => {
    if (!!query.id) {
      getDetail()
    }
  }, [query.id, token]);

  useEffect(() => {
    if (!!detail && !!detail.id) {
      const liveBottomFix = document.querySelector('.live-bottom-fix');
      const liveTopFix = document.querySelector('.live-top-fix');
      if (!!liveBottomFix && !!liveTopFix) {
        liveBottomFix.style.top = liveTopFix.offsetHeight + 'px';
      }
    }
  }, [detail.id]);

  //滑动到底部
  useEffect(() => {
    if (!!interactionData.length) {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
      var liveInteractionHeight = document.querySelector('.live-interaction-box').offsetHeight;
      var liveTopHeight = document.querySelector('.live-top-fix').offsetHeight;
      var lastHeight = 0 ;
      var messageBoxList = document.querySelectorAll('.live-interaction-top-item-box');
      var diffHeight = liveInteractionHeight + liveTopHeight - getWindowHeight() - scrollTop;
      if(messageBoxList && messageBoxList.length){
        //最后一条消息的高
        lastHeight = messageBoxList[messageBoxList.length - 1].offsetHeight
      }
      var diff = diffHeight - lastHeight;
      if (diff >= -1 && diff <= 1) {
        //判断当前最后消息处
        if(document.body){
          document.body.scrollTop = liveInteractionHeight + liveTopHeight - getWindowHeight();
    　　 }
    　　 if(document.documentElement){
  　　　　 document.documentElement.scrollTop = liveInteractionHeight + liveTopHeight - getWindowHeight();
    　　 }
      }
    }
  }, [interactionData]);

  const status = detail.status || -1;
  useEffect(() => {
    if (status === 2 && !teletextWs && menuTabKey === 1) {
      teletextWebSocketLive();
    }
    if (!interactionWs && menuTabKey === 5) {
      interactionWebSocketLive();
    }
  }, [status,menuTabKey]);

  const initMescrollDown = (mescrollId) => {
    return new MeScroll(mescrollId, {
      down: {
        offset: 50,
        auto: false,
        warpClass: '',
        noMoreSize: 1,
        htmlLoading: '<div class="d-f f-c-c f-s-14 c-ffffff191c27 student-list-interaction">加载中..</div>',
        htmlNodata: '<div class="d-f f-c-c f-s-14 c-ffffff191c27 student-list-interaction">到底了</div>',
        showNoMore: (mescroll, upwarp) => {
          const listStatus = document.querySelector('.student-list-interaction');
          if (!!listStatus) {
            listStatus.innerHTML = '到顶了';
          }
        },
        callback: () => {
          console.log('到顶了');
          getInteractionData(page)
        },
        isBounce: false,
      },
      up: {
        use: false,
      },
    });
  };

  const initMescrollUp = (mescrollId) => {
    return new MeScroll(mescrollId, {
      down: {
        use: false,
      },
      up: {
        offset: 50,
        auto: false,
        warpClass: '',
        noMoreSize: 1,
        showNoMore: (mescroll, upwarp) => {
          const listStatus = document.querySelector('.student-list-interaction');
          if (!!listStatus) {
            listStatus.innerHTML = '到底了';
          }
        },
        callback: () => {
          getHisLiveData(orderBy, page)
        },
        isBounce: false,
      },
    });
  };

  const getDetail = () => {
    axios.get('/api/v1/live/detail/' + query.id, {
      timeout: 5000,
      params: {
        os: query.os || 'web',
        version: query.sv,
      },
      headers: {token},
    }).then((res) => {
      if (res.data.code === 200 && res.data.data) {
        const data = res.data.data;
        if(data){
          setDetail(data);
          const {begin_time,is_join,status,tag,title,share_logo} = data;
          if (typeof setWeixinData !== 'undefined') {
            var desc = dayjs(begin_time * 1000).format("YYYY-MM-DD HH:mm");
            setWeixinData(title, desc, share_logo);
          }

          if (status === 1) {
            drawTabContent(4)//详情
          } else {
            if ((tag === '免费' || token) && is_join) {
              drawTabContent(1)//图文直播
            } else {
              drawTabContent(4)//详情
            }
          }

          // 未开始
          if (status === 1) {
            timer(begin_time - (Date.parse(new Date()) / 1000).toFixed(0));
          } else if(status === 2 ){
            // 直播中
            if (is_join) {
              initPlayer(true)
            } else {
              setShowPlayButton(true);
            }
          } else if(status === 4){
            if(is_join){
              // 初始化 video
              initPlayer();
              setShowPlayButton(true)
            }else{
              setShowPlayButton(true)
            }
          }
        }
      }
    }).catch((error) => {
    });
  };

  //初始化播放器
  const initPlayer  = (is_live) => {
    player = videojs('myVideo', {
      controlBar: {
        pictureInPictureToggle: false,// 禁用画中画
        currentTimeDisplay:true,
        timeDivider:true,
        durationDisplay:true,
      },
    }, function onPlayerReady() {
      if (is_live) {
        // 开始加载
        this.on('loadstart', function () {
          // 去除加载动画
          if (!!document.querySelector('.vjs-loading-spinner')) {
            document.querySelector('.vjs-loading-spinner').style.display = 'none'
          }
        });
      }
      // 视频播放
      this.on('play', function () {
        setShowPlayButton(false);// 隐藏播放按钮
      });
      // 视频结束
      this.on('ended', function () {
        setShowPlayButton(true);// 绘制播放按钮
      });
      // 视频暂停
      this.on('pause', function () {
        setShowPlayButton(true);// 绘制播放按钮
      });
      // 视频错误
      this.on('error', function () {
        setShowPlayButton(false);// 隐藏播放按钮
        // 去除错误交互
        if (!!document.querySelector('.vjs-error-display')) {
          document.querySelector('.vjs-error-display').style.display = 'none'
        }
        setPlayError(true)
      });
    });
    if (!!document.querySelector('.vjs-big-play-button')) {
      document.querySelector('.vjs-big-play-button').style.display = 'none'
    }
  };

  // 播放回放视频事件
  const play = () => {
    if (!(detail.tag === '免费' || token)) {
      setShowLogin(true)
    } else if (!detail.is_join) {
      drawErrorModal('请先参加报名')
    } else {
      if (player) {
        player.play();
      }
    }
  };

  //排序
  const handleSort = () => {
    setOrderBy(orderBy === 'asc' ? 'desc' : 'asc');
    getHisLiveData(orderBy === 'asc' ? 'desc' : 'asc');
  };

  // 倒计时
  const timer = (intDiff) => {
    if (typeof intDiff === 'number' && intDiff > 0) {
      timeID = window.setInterval(function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0;//时间默认值
        if (intDiff > 0) {
          day = Math.floor(intDiff / (60 * 60 * 24));
          hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
          minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
          second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
        } else {
          window.clearInterval(timeID)
        }
        if (day <= 9) day = '0' + day;
        if (hour <= 9) hour = '0' + hour;
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
        setTimerText(day + "天 " + hour + '时 ' + minute + '分');
        intDiff--;
      }, 1000);
    } else {
      setTimerText('00天 00时 00分')
    }
  };

  //预约/取消预约
  const handleBook = () => {
    if (!token) {
      setShowLogin(true);
    } else {
      axios.get(`/api/v1/live/booking/${detail.has_booking ? 'cancel' : 'add'}/${detail.id}`, {
        timeout: 5000,
        params: {
          os: query.os || 'web',
          version: query.sv,
        },
        headers: {token},
      }).then((res) => {
        if (res) {
          const newDetail = Object.assign({}, detail);
          newDetail.has_booking = !detail.has_booking;
          newDetail.join_member_total = detail.has_booking ? detail.join_member_total - 1 : detail.join_member_total + 1;
          setDetail(newDetail);
        }
      }).catch((error) => {
      });
    }
  };

  const showMenuTab = (detail,key) => {
    const {status,live_type,im_disabled} = detail;
    var showTab1 = true;
    var showTab2 = true;
    var showTab3 = true;
    var showTab4 = true;
    var showTab5 = true;
    if (!(live_type === 1 && [3, '3', 4, '4'].includes(status))) {// 不是学习模块的“结束” and “回放”，去除"文字稿" and "文件"
      showTab2 = false;
      showTab3 = false;
    }
    if (status === 1) {
      showTab1 = false;
      showTab2 = false;
    } 
    if(im_disabled){
      showTab5 = false;
    }
    switch (key){
      case 1:
        return showTab1;
      case 2:
        return showTab2;
      case 3:
        return showTab3;
      case 4:
        return showTab4;
      case 5:
        return showTab5;
      default:
        return true
    }
  };

  const drawErrorModal = (msg) => {
    if (msg) {
      setErrorText(msg);
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () {
        setErrorText('');
      }, 3500)
    }
  };

  //点击菜单验证
  const clickMenu = (key) => {
    if ((detail.tag === '免费' || token) && detail.is_join) {
      if(key !== menuTabKey){
        drawTabContent(key)
      }
    } else {
      drawErrorModal('请先参加报名')
    }
  };
  //点击菜单修改tab
  const drawTabContent = (key) => {
    pannelKey = key;
    interactionWs && interactionWs.close();
    teletextWs && teletextWs.close();
    if(menuTabKey !== 1 || menuTabKey !== 5){
      clearTimeout(connectTimer);
      clearInterval(intervalTimer);
    }
    // 1:图文直播  2:文字稿 3:文件 4:详情介绍 5:互动
    setMenuTabKey(key);
    page = '';
    interactionList = [];
    imageLiveList = [];
    if(mescrollDom){
      mescrollDom.destroy();
    }
    if (key !== 5) {
      if(document.documentElement){document.documentElement.scrollTop = 0}
      if(document.body){document.body.scrollTop = 0}
    }
    if(key === 1){
      mescrollDom = initMescrollUp('body');
      //图文直播
      setImageLiveData([]);
      getHisLiveData(orderBy);
    } else if(key === 5){
      mescrollDom = initMescrollDown('body');
      //互动
      setInteractionData([]);
      getInteractionData();
    }
  };

  // 获取图文直播内容
  const getHisLiveData = (orderBy,page_no) => {
    var lastTime = page_no || '';
    axios.get('/api/v1/live/webcast_text/' + query.id, {
      timeout: 5000,
      params: {
        LiveID: query.id,
        OrderBy: orderBy,
        os: query.os || 'web',
        LastTime: lastTime
      },
      headers: {token},
    }).then((res) => {
      if (!!res && res.status === 200 && res.data) {
        if (res.data.code === 200 && Array.isArray(res.data.data && res.data.data.rows)) {
          const dataList = res.data.data.rows;
          if (dataList.length > 0) {
            //设置列表
            imageLiveList = !page_no ? dataList : imageLiveList.concat(dataList);
            //设置最后时间
            page = dataList[dataList.length - 1].create_time ? dataList[dataList.length - 1].create_time : ''
            setImageLiveData(imageLiveList);
            if (dataList.length < 10) {
              mescrollDom.endSuccess(dataList.length, false);
              mescrollDom.showNoMore();
            } else {
              mescrollDom.endSuccess(dataList.length, true);
            }
          } else {
            mescrollDom.endSuccess(0, false);
            mescrollDom.showNoMore();
            //首次请求,结果为空就一直为空;非首次请求，不做操作
            if (!page_no) {
              imageLiveList = [];
              setImageLiveData(imageLiveList);
            }
            page = Array.isArray(imageLiveList) && imageLiveList.length ? (imageLiveList[imageLiveList.length - 1].create_time || '') : '';
          }
        } else {
          mescrollDom.endSuccess(0, false);
          mescrollDom.showNoMore();
          //首次请求,结果为空就一直为空;非首次请求，不做操作
          if (!page_no) {
            imageLiveList = [];
            setImageLiveData(imageLiveList);
          }
          page = Array.isArray(imageLiveList) && imageLiveList.length ? (imageLiveList[imageLiveList.length - 1].create_time || '') : '';
        }
      }
    }).catch((error) => {
      mescrollDom.endErr();
      //网络错误，不做操作,最后时间选当前
      page = Array.isArray(imageLiveList) && imageLiveList.length ? (imageLiveList[imageLiveList.length - 1].create_time || '') : '';
    });
  };

  // 获取互动内容
  const  getInteractionData = (page_no) => {
    var lastTime = page_no || '';
    axios.get('/im/host/message/history', {
      timeout: 5000,
      params: {
        channel_id: query.id,
        last_read_time: lastTime,
        page_size: 10,
        source: 'lj'
      },
      headers: {token},
    }).then((res) => {
      if(!!res && res.status === 200 && res.data){
        if(res.data.code === 200 && Array.isArray(res.data.data && res.data.data.list)){
          const dataList = res.data.data.list;
          if (dataList.length > 0) {
            //设置列表
            interactionList = !page_no ? dataList : dataList.concat(interactionList);
            //设置最后时间
            page = dataList[0].props && dataList[0].props.timestamp ? dataList[0].props.timestamp : '';
            setInteractionData(interactionList);
            // //第一次进来滑动到页面底部       
            if(!page_no){
              //PC浏览器
              document.documentElement.scrollTop = document.body.scrollHeight || 0;
              //手机自带浏览器
              document.body.scrollTop = document.body.scrollHeight || 0;
            }
            if (dataList.length < 10) {
              mescrollDom.endSuccess();
              mescrollDom.showNoMore();
            } else{
              mescrollDom.endSuccess();
            }
          } else {
            mescrollDom.endSuccess();
            mescrollDom.showNoMore();
            //首次请求,结果为空就一直为空;非首次请求，不做操作
            if (!page_no) {
              interactionList = [];
              setInteractionData(interactionList);
            }
            page = Array.isArray(interactionList) && interactionList.length ? (interactionList[0].props.timestamp || '') : '';
          }
        }else{
          mescrollDom.endSuccess();
          mescrollDom.showNoMore();
          //首次请求,结果为空就一直为空;非首次请求，不做操作
          if (!page_no) {
            interactionList = [];
            setInteractionData(interactionList);
          }
          page = Array.isArray(interactionList) && interactionList.length ? (interactionList[0].props.timestamp || '') : '';
        }
      }
    }).catch((error) => {
      mescrollDom.endErr();
      //网络错误，不做操作,最后时间选当前
      page = Array.isArray(interactionList) && interactionList.length ? (interactionList[0].props.timestamp || '') : '';
    });
  }

  //图文直播内容流 websocket
  const teletextWebSocketLive = () => {
    if (detail.tag === '免费'|| token) {
      // 判断浏览器是否支持 WebSocket
      if ("WebSocket" in window) {
        var origin = window.location.origin;
        origin = ['t-api3', 'localhost'].some(function (item) {
          return origin.includes(item)
        }) ? 't-api3.jingpt.com' : 'api3.jingpt.com';
        var wsUrl = 'wss://' + origin + '/ws/liveTelecast?deviceId=' + token + '&liveTelecastId=' + query.id;
        // 打开一个 web socket
        teletextWs = new WebSocket(wsUrl);
        // Web Socket 已连接上，使用 send() 方法发送数据
        teletextWs.onopen = function () {
          clearInterval(intervalTimer);
          intervalTimer = setInterval(function () {
            if (teletextWs) teletextWs.send("9");
          }, 10000)
        };
        // 客户端接收服务端数据时触发
        teletextWs.onmessage = function (evt) {
          if(JSON.parse(evt.data).create_time){
            setImageLiveData(preState => {
              return orderBy === 'desc' ? [JSON.parse(evt.data),...preState] : [...preState,JSON.parse(evt.data)];
            })
          }
        };
        // 通信发生错误时触发
        teletextWs.onerror = function () {
          console.log(new Date(), '连接发生错误...');
          teletextWs = null;
          if(pannelKey === 1){
            clearTimeout(connectTimer);
            connectTimer = setTimeout(function(){
              console.log("图文直播WS已重连...");
              teletextWebSocketLive();
            }, 3000);
          }
        };
        // 关闭 websocket
        teletextWs.onclose = function () {
          console.log("图文直播WS已关闭...");
          teletextWs = null;
          if(pannelKey === 1){
            clearTimeout(connectTimer);
            connectTimer = setTimeout(function(){
              console.log("图文直播WS已重连...");
              teletextWebSocketLive();
            }, 3000);
          }
        }
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    }
  }

  // 互动内容流 websocket
  const interactionWebSocketLive = () => {
    if (detail.tag === '免费'|| token) {
      // 判断浏览器是否支持 WebSocket
      if ("WebSocket" in window) {
        var origin = window.location.origin;
        origin = ['t-api3', 'localhost','172.16.40.164'].some(function (item) {
          return origin.includes(item)
        }) ? 't-im.jingpt.com' : 'im.jingpt.com';
        var wsUrl = 'wss://' + origin + '/api/v1/ws?device_id=' + token + '&channel_id=' + query.id + '&source=lj';
        // 打开一个 web socket
        interactionWs = new WebSocket(wsUrl);
        // Web Socket 已连接上，使用 send() 方法发送数据
        interactionWs.onopen = function () {};
        // 客户端接收服务端数据时触发
        interactionWs.onmessage = function (evt) {
          var resultData = {};
          try {
            resultData = JSON.parse(evt.data);
          } catch (e) {
            resultData = {};
          }
          if(!!resultData.props && !!resultData.props.timestamp){
            setInteractionData(preState => {
              return [...preState,resultData]
            })
          }
        };
  
        // 通信发生错误时触发
        interactionWs.onerror = function () {
          console.log(new Date(), '互动WS连接发生错误...');
          interactionWs = null;
          if(pannelKey === 5){
            clearTimeout(connectTimer);
            connectTimer = setTimeout(function(){
              console.log("互动WS已重连...");
              interactionWebSocketLive();
            }, 3000);
          }
        };
        // 关闭 websocket
        interactionWs.onclose = function () {
          console.log("互动WS已关闭...");
          interactionWs = null;
          if(pannelKey === 5){
            clearTimeout(connectTimer);
            connectTimer = setTimeout(function(){
              console.log("互动WS已重连...");
              interactionWebSocketLive();
            }, 3000);
          }
        }
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    }
  };

  //登录
  const handleLogin = () => {
    if(token){
      axios({
        method: 'post',
        url: `/api/v1/live/join/${query.id}?os=${query.os}`,
        timeout: 5000,
        headers: {token}
      }).then(res => {
        if(res && res.status === 200 && res.data){
          const {code,msg} = res.data;
          if(code === 200){
            drawErrorModal('报名成功');
            getDetail();
          }else{
            if(code === 401){
              removeCookies();
              setShowLogin(true);
            }else{
              drawErrorModal(msg || '')
            }
          }
        }
      }).catch(error => {})
    }else{
      //验证码登录
      setShowLogin(true)
    }
  };

  const setChangeShowLogin = (value) => {
    setShowLogin(value);
  };

  return (
    <>
      <Helmet>
        <body className="bg-c-0f1214ffffff s-body"/>
        <title>{detail.title || '直播'}</title>
        <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/css/video-js.css`} />
        <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/css/mescroll.min.css`} />
      </Helmet>
      <div className="w-100p m-w-480 live-top-fix">
        <OpenApp openUrl={!!query.id ? `lanjing://live?detail_id=${query.id}&type=1` : ''}/>
        <section className="bg-c-0f1214ffffff live-wrap">
          {/*  1:未开始  3:直播结束 */}
          {
            (detail.status === 1 || detail.status === 3) &&
            <>
              <div className="w-100p h-100p live-box">
                <div className="d-f f-c-c f-d-c m-w-480 bg-c-0f1214-70 live-box-mask">
                  {
                    detail.status === 1 ?
                    <div className="t-a-c">
                      <div className="d-f f-c-c o-h f-s-13 c-afb0b3ffffff live-box-mask-top">
                        <div/>
                        <div>倒计时</div>
                        <div/>
                      </div>
                      <div className="f-s-24 f-w-b c-fff live-box-mask-bottom">
                      {timerText}
                      </div>
                      <div className={`d-i-f f-c-c f-s-15 c-fff ${detail.has_booking ? 'bg-c-5e5e69aaaaaa' : 'bg-c-f29130b37000-ffdea8'} live-appointment-button`} onClick={() => handleBook(detail)}>{detail.has_booking ? '已预约' : '我要预约'}</div>
                    </div> :
                    <div className="f-s-14 c-fff l-h-161538 t-a-c">
                      <div>直播已结束</div>
                      <div>应发布方要求不可回放</div>
                    </div>
                  }
                </div>
                <img className="w-100p h-100p o-f-c" alt="" src={detail&&detail.img} />
              </div>
              {
                showPlayButton &&
                <div className="d-f f-c-c f-s-12 l-h-1 c-fff live-status">
                  <div className={`f-w-600 t-a-c live-status-box ${detail.status === 1 ? 'bg-c-f29130cca166' : 'bg-c-5e5e69'}`}>{detail.status === 1 ? '已预约' : '已结束'}</div>
                  {typeof detail.join_member_total === 'number' && detail.join_member_total > 0 && <div className={`live-number ${detail.status === 1 ? 'b-c-f291305e5e69' : 'b-c-5e5e69'}`}>{`${numberUtil(detail.join_member_total) || 0}人${detail.status === 1 ? '' : '参与'}`}</div>}
                </div>
              }       
            </>
          }

          {/* 直播中、回放 */}
          {
            detail.status === 2 || detail.status === 4 ?
            <>
              {
                (detail.status === 2 && detail.is_join && !detail.hls_url) || (detail.status === 4 && detail.is_join && !detail.replay_url) || playError ?
                <OpenAppChannel className="d-f f-c-c f-s-12 l-h-1 c-fff bg-c-000 live-status live-status-error" openUrl={!!query.id ? `lanjing://live?detail_id=${query.id}&type=1` : ''}>
                  打开APP播放
                </OpenAppChannel>
                : null
              }
              {
                showPlayButton &&
                <div className="d-f f-c-c m-w-480 bg-c-0f1214-70 live-box-mask">
                  <div onClick={play} className="play-b"><i className="iconfont icon-bofang" /></div>
                </div>
              }
              {
                <div className={`d-f f-c-c f-s-12 l-h-1 c-fff live-status`}>
                  <div className={`f-w-600 t-a-c live-status-box ${detail.status === 2 ? 'bg-c-d95757' : 'bg-c-1c288c1561f5'}`}>{detail.status === 2 ? '直播中' : '回放'}</div>
                  {typeof detail.join_member_total === 'number' && detail.join_member_total > 0 && <div className={`live-number ${detail.status === 2 ? 'b-c-d957575e5e69' : 'b-c-5e5e69'}`}>{`${numberUtil(detail.join_member_total) || 0 }人参与`}</div>}
                </div>
              }
              <div className="w-100p h-100p live-box m-w-480">
                {
                  detail.status === 2 &&
                  (
                    detail.is_join && detail.hls_url ?
                      <div className="w-100p h-100p">
                        <video id="myVideo" className="w-100p h-100p video-js vjs-default-skin" controls autoPlay={true} poster={detail&&detail.img} preload="auto"  webkit-playsinline="true" playsInline x5-playsinline="true" x-webkit-airplay='allow' >
                          <source src={detail.hls_url} type="application/x-mpegURL" />
                          <source src={detail.rtmp_url} type="rtmp/flv" />
                        </video>
                      </div>
                    : <img className="w-100p h-100p o-f-c" alt="" src={detail&&detail.img} />
                  )
                }
                {
                  detail.status === 4 &&
                  (
                    detail.is_join && detail.replay_url ?
                      <div className="w-100p h-100p">
                        <video id="myVideo" className="w-100p h-100p video-js vjs-default-skin" controls poster={detail&&detail.img} preload="none" data-setup="{}" webkit-playsinline="true" playsInline x5-playsinline="true" x-webkit-airplay='allow' >
                          {
                            detail.replay_url && detail.replay_url.indexOf('.m3u8') > -1 ?
                              <source src={detail.replay_url} type="application/x-mpegURL" /> :
                              <>
                                <source src={detail.replay_url} type="video/mp4" />
                                <source src={detail.replay_url} type="video/webm" />
                                <source src={detail.replay_url} type="video/ogg" />
                              </>
                          }
                        </video>
                      </div>
                    : <img className="w-100p h-100p o-f-c" alt="" src={detail&&detail.img} />
                  )
                }
              </div>
            </> 
            : null
          }
          
          {/* 默认 */}
          {
            !detail.status && <div className="w-100p h-100p live-box">
            <svg className="page-empty" width="50%" viewBox="0 0 148 44" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="state/videonodata" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(2.000000, 3.000000)" className="f-646566339aff">
                  <text className="l-h-17 f-w-b">
                    <tspan x="46" y="20">蓝鲸财经</tspan>
                  </text>
                  <path d="M38.3955171,18.2169689 C39.5979187,21.6707714 39.0659373,24.4538998 39.3302345,26.3068851 C39.5945316,28.1598704 40,28.8097075 40,30.7534014 C40,32.6970953 39.2642313,34.1228814 35.1043248,35.6725001 C32.3310539,36.7055792 27.1776725,36.9674084 19.6441809,36.4579875 C18.1758189,36.9506925 16.5742389,37.1074852 14.8394407,36.9283656 C12.2372434,36.6596862 10.0050112,36.0037079 9.74071408,35.4742835 C9.56451598,35.121334 9.68248484,34.9242926 10.0946206,34.8831595 C9.08072514,34.5065432 8.19973465,33.9771188 7.45164918,33.2948864 C6.7035637,32.612654 6.1032249,31.6132874 5.65063278,30.2967865 C4.05083014,30.2256965 2.80310614,29.8326095 1.90746076,29.1175256 C0.563992696,28.0448998 -0.212968064,26.4123697 0.0513290824,24.8240965 C1.10851767,24.5593844 1.96829593,24.6825364 2.4300034,24.8240965 C2.73780838,24.91847 3.26640267,25.2714196 4.01578628,25.8829453 C3.66339008,24.8240965 3.75148913,23.588773 4.28008342,22.1769747 C4.80867771,20.7651764 5.77776725,19.7063277 7.18735203,19.0004285 C8.77313491,20.5887016 9.56602635,22.3534495 9.56602635,24.2946722 C9.56602635,26.2358949 8.68503586,28.0888801 6.92305488,29.853628 C7.09925298,30.5595272 7.98024347,31.0889516 9.56602635,31.4419011 C11.9447007,31.9713255 12.2089978,30.1183402 11.6804035,28.2653549 C11.1518092,24.8240965 9.56602635,21.118126 11.6804035,17.1474432 C13.7947807,13.1767605 18.2613955,10.5951881 24.5429662,10.3674489 C30.8245368,10.1397096 36.9486562,13.9261842 38.3955171,18.2169689 Z M22.8881638,1.14182873 C24.162554,0.79206486 25.5308849,1.43697627 26.2982147,3.0248933 C26.809768,4.08350465 26.9194224,6.23446568 26.6271779,9.47777638 C26.0193806,8.1860348 25.6503233,7.41843649 25.5200061,7.17498147 C25.3245302,6.80979892 24.4222078,5.9180518 23.9139843,5.6287291 C23.4057608,5.3394064 22.0019201,4.90569645 21.4985544,3.94953357 C20.9951887,2.99337069 21.6137736,1.49159261 22.8881638,1.14182873 Z M30.5475733,2.75941813 C31.5340338,3.02305809 31.8832678,4.28840159 31.6195089,4.91261772 C31.3557499,5.53683385 30.184537,5.63334037 29.7553386,5.95217845 C29.3261401,6.27101653 28.6856269,6.9363816 28.5343159,7.21164363 C28.433442,7.39515164 28.112826,7.91522896 27.5724681,8.77187558 C27.4056757,6.41196147 27.5202671,4.83303202 27.9162424,4.03508724 C28.5102054,2.83817007 29.5611128,2.49577817 30.5475733,2.75941813 Z M30.1812037,7.35309241 C30.4731383,7.35309241 30.709798,7.59012378 30.709798,7.88251678 C30.709798,8.17490978 30.4731383,8.41194115 30.1812037,8.41194115 C29.8892692,8.41194115 29.6526095,8.17490978 29.6526095,7.88251678 C29.6526095,7.59012378 29.8892692,7.35309241 30.1812037,7.35309241 Z M29.0954209,7.88251678 C29.3715632,7.88251678 29.5954209,8.00103246 29.5954209,8.14722896 C29.5954209,8.29342547 29.3715632,8.41194115 29.0954209,8.41194115 C28.8192785,8.41194115 28.5954209,8.29342547 28.5954209,8.14722896 C28.5954209,8.00103246 28.8192785,7.88251678 29.0954209,7.88251678 Z M24.3380722,6.82366804 C24.6142146,6.82366804 24.8380722,6.94218373 24.8380722,7.08838023 C24.8380722,7.23457673 24.6142146,7.35309241 24.3380722,7.35309241 C24.0619299,7.35309241 23.8380722,7.23457673 23.8380722,7.08838023 C23.8380722,6.94218373 24.0619299,6.82366804 24.3380722,6.82366804 Z M30.1812037,1 C30.4731383,1 30.709798,1.23703136 30.709798,1.52942437 C30.709798,1.82181737 30.4731383,2.05884874 30.1812037,2.05884874 C29.8892692,2.05884874 29.6526095,1.82181737 29.6526095,1.52942437 C29.6526095,1.23703136 29.8892692,1 30.1812037,1 Z" />
                  <text>
                    <tspan x="46" y="35">专注深度报道，影响有影响力的人</tspan>
                  </text>
                </g>
              </g>
            </svg>
          </div>
          }
        </section>

        <section className="bg-c-171b1fffffff live-title-wrap">
          <div className="live-title-box">
            <div className="p-r o-h f-s-15 f-w-b l-h-141667 live-title-top">
              <span className="c-4f62ffcca166">{detail.source === '4' ? '转播' : detail.tag}</span>
              <span className="c-ffffff191c27"><span className="c-ffffff9ea5bb">｜</span>{detail.title}</span>
            </div>      
            <div className="d-f f-c-c o-h f-s-12 l-h-15 live-title-bottom">
              <div className={`w-100p live-title-bottom-time ${detail.status === 1 ? 'c-6465669395a2' : 'c-6465669395a2'}`}>
                {
                  typeof detail.begin_time === 'number' && typeof detail.end_time === 'number' && (
                  dayjs(detail.begin_time * 1000).format('YYYY-MM-DD') === dayjs(detail.end_time * 1000).format('YYYY-MM-DD') ?
                  `${dayjs(detail.begin_time * 1000).format('YYYY-MM-DD HH:mm')} - ${dayjs(detail.end_time * 1000).format('HH:mm')}`:
                  `${dayjs(detail.begin_time * 1000 ).format('YYYY-MM-DD HH:mm')} - ${detail.end_time ? dayjs(detail.end_time * 1000).format('YYYY-MM-DD HH:mm') : '23:59'}`)
                }
              </div>
              <div className="f-s-0 return-live-index">
                <a className="d-f f-s-13 f-w-b l-h-1375 c-fff bg-c-4f62ff339aff-84bfff return-live-index-button" href={setUrl((([1, '1'].includes(detail.live_type)) ? '/resources/html/student_live_index.html' : '/resources/html/live_index.html'),query,query.id)}>观看更多直播</a>
              </div>
            </div>
          </div>
        </section>

        <section className="d-f bg-c-171b1fffffff live-menu-wrap">
        {
          menuList.map((item,index) => {
            if(showMenuTab(detail,item.key)){
              return (<div
                key={index}
                className={`f-g-1 p-r f-s-16 l-h-157143 t-a-c ${menuTabKey === item.key ? 'f-w-b c-ffffff191c27 live-menu-icon' : 'c-afb0b39ea5bb'} live-menu-item`}
                onClick={() => {clickMenu(item.key)}}
              >{detail.live_type === 1 && item.key === 4 ? '详情介绍' : item.name}</div>)
            }else{
              return null
            }
          })
        }
      </section>
      </div>
      <section className="p-r w-100p bg-c-tf8fafd live-bottom-fix">
        {
          menuTabKey === 1 &&
          (
            detail.is_join ?
            // 图文直播（已报名）
            <section className="registered-wrap">
              <div className="live-total-wrap">
                {
                  detail.status !== 2 &&
                  <div className="o-h f-s-12 l-h-14 b-c-1e252be8e8f3 live-total-box">
                    <div className="f-l c-afb0b39ea5bb">共 <span className="live-total-number">{Array.isArray(imageLiveData) ? imageLiveData.length : 0}</span> 条消息</div>
                    <div className="f-r o-h c-6465669ea5bb">
                      <div className="f-l">时间排序：</div>
                        <div className="d-f f-c-c f-r o-h f-w-b live-total-sort" onClick={handleSort}>
                          <div className="f-l">
                            <span className={orderBy === 'asc' ? 'c-4f62ff1561f5' : ''}>升序</span>/
                            <span className={orderBy === 'desc' ? 'c-4f62ff1561f5' : ''}>降序</span>
                          </div>
                          <div className={`f-r ${orderBy === 'asc' ? 'live-total-icon-up' : 'live-total-icon-down'}`} />
                        </div>
                      </div>
                  </div>
                }
              </div>

              <div className="o-h live-barrage-warp" id="live-barrage-warp">
                {
                  Array.isArray(imageLiveData) && !!imageLiveData.length ?
                  imageLiveData.map((item, index) => {
                    const {spoke_text,spokesman,resource_url,media_type,head_photo,video_snapshot,create_time,status,id,img_list} = item;
                    var imgList = (Array.isArray(img_list) && img_list.length) ? img_list[0] : (img_list && typeof img_list === 'string' ? img_list : '')
                    return(
                      [0, '0', 3, '3'].includes(status) ? <div className="d-f f-s-s w-100p o-h live-barrage-box" name={create_time} key={id}>
                        <div className="f-s-0 o-h live-barrage-left">
                          <img className="h-100p w-100p" alt="" src={head_photo} />
                        </div>
                        <div className="f-g-1 live-barrage-box-right">
                          <div className="o-h f-s-12 l-h-15 live-barrage-box-right-top">
                            <div className="c-ffffff191c27">{spokesman}</div>
                            <div className="c-ffffff9395a2">{typeof create_time === 'number' && dayjs(create_time * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                          </div>
                          <div className="f-s-14 l-h-142858 c-afb0b35a6073 live-barrage-right-middle">{spoke_text || "无"}</div>
                          {
                            imgList && 
                            <div className={Array.isArray(img_list) && !!img_list.length ? 'live-barrage-right-image-bottom' : 'live-barrage-right-bottom'}>
                              <div className={`p-r ${Array.isArray(img_list) && !!img_list.length ? 'live-barrage-right-image-bottom-warp' : 'live-barrage-right-bottom-warp'}`}>
                                <div className="w-100p h-100p live-barrage-right-bottom-box">
                                  {
                                    media_type === 2 ?
                                    <video className="w-100p h-100p" controls poster={video_snapshot} preload="auto">
                                      <source src={resource_url} type="video/mp4" />
                                      <source src={resource_url} type="video/webm" />
                                      <source src={resource_url} type="video/ogg"/>
                                      您的浏览器不支持 HTML5 video 标签
                                    </video> :
                                    <PhotoSwipeGallery imagePhoto={Array.isArray(img_list) && !!img_list.length ? img_list : [imgList]} index={index} />
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div> :null
                    )
                  }):<div className="t-a-c studio-empty-live">
                    <div className="studio-empty-live-image" />
                    <div className="f-s-14 l-h-142858 c-6465669ea5bb studio-empty-live-text">暂无数据</div>
                  </div>
                }
                {Array.isArray(imageLiveData) && !!imageLiveData.length && <div className="d-f f-c-c w-100p c-afb0b3646566 live-barrage-warp-bottom">到底了</div>}
              </div>
            </section> :
            // 图文直播（未报名）
            <section className="t-a-c not-registered-box">
              <div className="not-registered-image" />
              <div className="f-s-14 l-h-142858 c-6465669ea5bb studio-empty-live-text">请先参加报名</div>
            </section>
          )
        }
        {/* 文字稿 */}
        {
          menuTabKey === 2 &&
          <section className="transcript-box">
            {/*<div className="f-s-24 f-w-600 c-ffffff191c27 l-h-157143 transcript-title">{detail.course_summary &&  detail.course_summary.title ? detail.course_summary.title : ''}</div>*/}
            {/*<div className="p-r d-f f-s-c b-c-1e252be8e8f3 transcript-avatar">*/}
              {/*{*/}
                {/*detail.course_summary && detail.course_summary.author_avatar && <img alt="" className="o-f-c bg-c-fff transcript-avatar-icon" src={detail.course_summary.author_avatar}/>*/}
              {/*}*/}
              {/*<span className="f-s-12 c-ffffff191c27 transcript-avatar-name">{detail.course_summary && detail.course_summary.author_name ? detail.course_summary.author_name : ''}</span>*/}
              {/*<span className="f-s-12 c-6465669395a2 transcript-avatar-time">{detail.course_summary && detail.course_summary.create_time ? (dayjs(detail.course_summary.create_time * 1000).format('YYYY-MM-DD HH:mm') ) : ''}</span>*/}
            {/*</div>*/}
            <div className="f-s-16 l-h-161538 c-afb0b3646566 transcript-content">{detail.course_summary && detail.course_summary.content ? detail.course_summary.content : ''}</div>
          </section>
        }
        {/* 文件 */}
        {
          menuTabKey === 3 &&
          <section className="courseware-box">
            {
              detail && Array.isArray(detail.course_files) &&
                detail.course_files.map((item,index) => {
                  return(
                    <div className="p-r courseware-item-wrap" key={index}>
                      <div className="o-h courseware-item-box">
                        <img src={item} alt="" className="w-100p h-100p o-f-c"/>
                      </div>
                    </div>
                  )
                })
            }
          </section>
        }
        {/* 详情 */}
        {
          menuTabKey === 4 &&
          <section className="live-detail-box">
            <div className="f-s-18 f-w-600 c-ffffff191c27">简介</div>
            <div className="f-s-16 c-afb0b3646566 l-h-161538 live-detail-content" dangerouslySetInnerHTML={{__html:detail.description}} />
          </section>
        }
        {/* 互动 */}
        {
          menuTabKey === 5 &&
          <>
            <section className="p-r o-h live-interaction-box">
              <div className="live-interaction-top-box">
                {Array.isArray(interactionData) && !!interactionData.length ?
                  interactionData.map((data,index) => {
                    if(!!data.props && !!data.props.timestamp){
                      var nowTime = dayjs(new Date().valueOf()).format('YYYY-MM-DD');
                      var itemTime = dayjs(data.props.timestamp.substring(0, 10) * 1000).format('YYYY-MM-DD HH:mm');
                      if(nowTime.substring(0, 10) === itemTime.substring(0, 10)){
                        itemTime = itemTime.substring(11);
                      }
                      var userAvatar = 'https://file.jingpt.com/wap/images/default_avatar-830.png';
                      if(!!data.sender.user_avatar){
                        userAvatar = data.sender.user_avatar;
                      } 
                      var itemPrefixType;
                      if (data.media_type && data.media_type === 8) {// 提问
                        itemPrefixType = 1;
                      } else if (data.media_type && data.media_type === 10 && Array.isArray(data.alert_range) && data.alert_range.length > 0) {// 包含at信息
                        itemPrefixType = 2;
                      }
                      var itemMessageType;
                      if (data.media_type && data.media_type === 1) {// 图片
                        itemMessageType = 1;
                      } else {// 文本
                        if (data.sender.user_roll && data.sender.user_roll === 2) {// 本人
                          itemMessageType = 2;
                        } else {// 普通用户 | 主持人
                          itemMessageType = 3;
                        }
                      }
                      var itemRollType;
                      if (data.sender.user_roll && data.sender.user_roll === 2) {// 本人
                        itemRollType = 1;
                      } else {// 普通用户 | 主持人
                        itemRollType = 2;
                      }
                      var identityType = 0;
                      if(data.sender.id === detail.anchor){
                        identityType = 1 //主持人
                      }else if(detail.guests && Array.isArray(detail.guests) && detail.guests.indexOf(data.sender.id) > -1){
                        identityType = 2 //嘉宾
                      }

                      return (
                        <div className="w-100p live-interaction-top-item-box" key={index}>
                          <div className="t-a-c f-s-12 c-6465669395a2 l-h-166667 live-interaction-top-item-time">{itemTime}</div>
                          <div className={`d-f ${itemRollType === 1 ? 'f-e-c' : 'f-s-c'} live-interaction-top-item-user`}>
                            {
                              itemRollType === 1 &&
                              <div className="d-f f-s-c f-s-12 l-h-133333 live-interaction-top-item-user-name-right">
                                {
                                  !!identityType &&
                                  <div className={`c-fff ${identityType === 1 ? 'bg-c-4f62ff2953ff' : 'bg-c-e64545cca166'} t-s-83333 person-viewpoint-number article-comment-reply`}>
                                    {identityType === 1 ? '主持人' : '嘉宾'}
                                  </div>
                                }
                                <div className="c-4f62ff">我</div>
                              </div>
                            }
                            <div className={`default-avatar ${itemRollType === 1 ? 'b-c-1a73e8 live-interaction-top-item-user-img-right-box' : 'o-h live-interaction-top-item-user-img-left-box'}`}>
                              {!!userAvatar && <img src={userAvatar} alt="" className="w-100p h-100p o-f-c live-interaction-top-item-user-img" />}
                            </div>
                            {
                              itemRollType === 2 &&
                              <div className="d-f f-s-c f-s-12 l-h-133333 live-interaction-top-item-user-name-left">
                                <div className="c-ffffff191c27">{data.sender.user_name}</div>
                                {
                                  !!identityType &&
                                  <div className={`c-fff ${identityType === 1 ? 'bg-c-4f62ff2953ff' : 'bg-c-e64545cca166'} t-s-83333 person-viewpoint-number article-comment-reply`}>
                                    {identityType === 1 ? '主持人' : '嘉宾'}
                                  </div>
                                }
                              </div>
                            }
                          </div> 
                          <div className={`d-f w-100p ${itemRollType === 1 ? 'f-e-c live-interaction-top-item-content-right-wrap' : 'live-interaction-top-item-content-left-wrap'}`}>
                            <div className={`d-f ${itemRollType === 1 ? 'f-e-c' : ''} live-interaction-top-item-content-box`}>
                              {itemMessageType === 1 && 
                                <div>
                                  <img src={data.medias[0]} alt="" className="live-interaction-top-item-content-image" />
                                </div>
                              }
                              {itemMessageType === 2 &&
                                <div className="f-s-14 c-ffffff191c27 l-h-142858 bg-c-4f62ff-20c0deff live-interaction-top-item-content-right">
                                  {itemPrefixType === 1 && <div className="f-l d-f f-s-c"><div className="f-s-1 live-interaction-top-item-content-help"/>提问:</div>}
                                  {itemPrefixType === 2 && `${data.alert_range[0]}: `}
                                  <span dangerouslySetInnerHTML={{__html: formatExpression(data.message_body)}} />
                                </div>
                              }
                              {itemMessageType === 3 &&
                                <div className="f-s-14 c-ffffff191c27 l-h-142858 bg-c-1e252be9f3ff live-interaction-top-item-content-left">
                                  {
                                    itemPrefixType === 1 &&
                                    <div className="f-l d-f f-s-c"><div className="f-s-1 live-interaction-top-item-content-help"/>提问:</div>
                                  }
                                  {
                                    itemPrefixType === 2 && `${data.alert_range[0]}: `
                                  }
                                  <span dangerouslySetInnerHTML={{__html: formatExpression(data.message_body)}} />
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      )
                    }else{
                      return null
                    }
                  }) :
                  <div className="t-a-c studio-empty-live">
                    <div className="studio-empty-live-image" />
                    <div className="f-s-14 l-h-142858 c-6465669ea5bb studio-empty-live-text">暂无数据</div>
                  </div>
                }
              </div>
            </section>
            <OpenAppChannel className="w-100p m-w-480 bg-c-1e252bffffff live-interaction-bottom-box" openUrl={!!query.id ? `lanjing://live?detail_id=${query.id}&type=1` : ''}>
              <div className="d-f f-c-c live-interaction-bottom-action">
                <input className="w-100p f-s-14 l-h-125 c-ffffff646566 bg-c-171b1ff8fafd live-interaction-bottom-action-input" placeholder="说点什么与嘉宾进行互动…" disabled/>
                <div className="f-s-0 t-a-c live-interaction-bottom-action-help-box">
                  <div className="f-s-1 live-interaction-bottom-action-help"/>
                  <div className="f-s-12 c-4f62ff0381ff l-h-114286">提问</div>
                </div>
              </div>
            </OpenAppChannel>
          </>   
        }
      </section>
      
      {/* 报名 */}
      {
        !(detail && detail.is_join) && <section className="sign-up-wrap">
          <div className="d-f f-c-c m-w-480 f-s-16 f-w-600 c-fff bg-c-6776df-4f62ff39aff-84bfff c-p sign-up-box w-100p" onClick={handleLogin}>
            {
              detail.tag === '付费' ?
              (
                detail.status === 4 ? `回听需支付${detail.live_price}蓝鲸币` :
                detail.status === 3 ? `查看需支付${detail.live_price}蓝鲸币` : `参会需要支付${detail.live_price}蓝鲸币，立即报名`
              ):(detail.tag === '定向邀约' ? '仅针对定向邀约用户开放' : '名额有限，立即报名')
            }
          </div>
        </section>
      }

      {/* 错误提示 */}
      {errorText && 
        <section className="w-100p h-100p global-message-wrap">
          <div className="f-s-16 bg-c-000 c-afb0b3 global-message-box">{errorText}</div>
        </section>
      }

      {/* 登录 */}
      {showLogin && <Login type="code" isShow={showLogin} setIsShow={setChangeShowLogin} />}
    </>
  );
};

export default observer(Live);